export default "__VITE_ASSET__MyjgXL2v__"